import { isClientSide } from "./utils/environment";

if (isClientSide()) {
  window.global ||= window;
}

export {};
